"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchMapper = void 0;
const mapper_1 = require("./mapper");
const postRating_1 = require("./postRating");
class SearchMapper {
    static mapSearchResult(data) {
        // Response format: [ReqID, Status, Count, [Results...]] or just [Results...] from transport?
        // Based on ProfileService example, transport.send returns the "Data" part.
        // If the raw response is [5000, 0, 10000, [...]], transport might return [10000, [...]]?
        // Or if transport returns raw payload (minus ReqID), then status is index 0.
        // Let's look at the user dump: [5000, 0, 10000, [...]]
        // Usually Client transport strips ReqID (5000) and matches it.
        // If status (0) is success, it resolves with the rest?
        // If transport resolves with `payload` excluding reqID: [0, 10000, [ ... ]]
        // BUT wait, standard 4pda response is [ReqID, Status, ...Data].
        // If transport strips ReqID, we get [Status, Count, Results].
        // If transport handles Status, we might just get [Count, Results].
        // Let's assume we get [Count, Results] logic based on Profile search.
        // Check if data[1] is array.
        let items = [];
        if (Array.isArray(data) && data.length >= 2 && Array.isArray(data[1])) {
            // data[0] is count, data[1] is results list
            items = data[1];
        }
        else if (Array.isArray(data) && Array.isArray(data[0]) && typeof data[0][0] === 'number') {
            // Maybe direct array of results? Unlikely for RC command.
            items = data;
        }
        else {
            // Check if index 3 is the array (Raw response passed through?)
            // [5000, 0, 10000, [Results]]
            if (Array.isArray(data) && Array.isArray(data[3])) {
                items = data[3];
            }
        }
        return items.map(item => {
            const type = item[0];
            if (type === 1) {
                return mapper_1.PdaMapper.map(item, this.SearchResultPostSchema);
            }
            else if (type === 2) {
                return mapper_1.PdaMapper.map(item, this.SearchResultTopicSchema);
            }
            else if (type === 4) {
                return mapper_1.PdaMapper.map(item, this.SearchResultArticleSchema);
            }
            return null;
        }).filter((item) => item !== null);
    }
}
exports.SearchMapper = SearchMapper;
SearchMapper.SearchResultPostSchema = {
    forumId: 1,
    topicId: 2,
    topicTitle: 3,
    postId: 4,
    userId: 6,
    userName: 7,
    userGroup: 8,
    postDate: { index: 11, map: (v) => mapper_1.PdaMapper.safeIsoDate(v) },
    text: 12,
    avatar: 13,
    signature: 14,
    attachments: { index: 15, map: (v) => mapper_1.PdaMapper.mapList(v, SearchMapper.SearchAttachmentSchema) },
    rating: { index: 16, map: (v) => (0, postRating_1.decodePostRating)(v).value },
    editInfo: {
        index: [17, 18, 19, 20],
        map: (v) => v[0] ? ({ date: mapper_1.PdaMapper.safeIsoDate(v[0]), userName: v[1], reason: v[2], userId: v[3] }) : undefined
    },
    bitmask: 5,
    lastActionDate: { index: 9, map: (v) => mapper_1.PdaMapper.safeIsoDate(v) },
    authorReputation: 10
};
SearchMapper.SearchAttachmentSchema = {
    id: 0,
    type: 1, // ?
    name: 2,
    size: 3,
    url: 4,
    width: 5,
    height: 6
};
SearchMapper.SearchResultTopicSchema = {
    id: 1,
    title: 2,
    description: 3,
    postsCount: 5,
    lastPostTs: { index: 6, map: (v) => mapper_1.PdaMapper.safeIsoDate(v) },
    lastUserId: 7,
    lastUserName: 8
};
SearchMapper.SearchResultArticleSchema = {
    id: 1,
    timestamp: { index: 2, map: (v) => mapper_1.PdaMapper.safeIsoDate(v) },
    authorId: 6,
    authorName: 7,
    commentsCount: 8,
    imageUrl: 9,
    title: 10,
    previewText: 11,
    tags: 12
};
